// extracted by mini-css-extract-plugin
export default {"overlay":"SB-z","bodyOpen":"TB-z","content":"UB-z","header":"VB-z","close":"WB-z","closeNoHeading":"XB-z"};